const formdata = [{
		inputdata: "",
		title: "产品代码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "200px",
		lablewith: "70px",
	},
	{
		inputdata: "",
		title: "产品名称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "200px",
		btx: true,
		lablewith: "75px",
	},
	{
		inputdata: "",
		title: "启效日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "date",
		width: "140px",
		lablewith: "65px",
	},
	{
		inputdata: "",
		title: "标准货值",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "numberpro",
		width: "95px",
		lablewith: "60px",
		minleft: 1,
		maxleft: 100,
		minrigth: 1,
		maxrigth: 100,
	},
	{
		inputdata: "",
		title: "是否启用",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "select",
		width: "210px",
		btx: true,
		lablewith: "70px",
		options: [{
				key: "1",
				value: "启用",
			},
			{
				key: "0",
				value: "停用",
			},
		],
	},
	{
		inputdata: "",
		title: "创建时间",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "date",
		width: "140px",
		lablewith: "70px",
	},
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "210px",
		btx: true,
		lablewith: "70px",
		options: [],
	},
	{
		inputdata: "",
		title: "LEVEL3",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "210px",
		btx: true,
		lablewith: "70px",
		options: [],
	},
];

export default formdata;